/**
 * Created by shobhitjain on 18/12/19.
 */

import React from 'react';
import PropTypes from 'prop-types';

/*
 * Search Text is component used for Searching on basis on CustomerID/ Investigation ID
 * params @onSearchTextChange @onSearchClick
 *
 * */

export const SearchText = React.forwardRef(
  ({ onSearchTextChange, onSearchClick }, ref) => (
    <div className="input-group search-panel">
      <input
        ref={ref}
        type="text"
        className="form-control"
        placeholder="Search"
        onChange={onSearchTextChange}
      />
      <span
        className="input-group-addon"
        style={{ cursor: 'pointer' }}
        onClick={onSearchClick}>
        <i className="fa fa-search" aria-hidden="true" />
      </span>
    </div>
  )
);

SearchText.propTypes = {
  onSearchClick: PropTypes.func.isRequired,
  onSearchTextChange: PropTypes.func.isRequired
};
